import { getAccountValidationForBackgroundCheckSchema } from '@/backend/features/background-check/shared/getAccountValidationForBackgroundCheckSchema';
import { BackgroundCheckType } from '@/backend/features/background-check/types';
import { ExtendedAccountData } from '@/backend/features/contact-management/entities/extended-account/types';

export function isBackgroundCheckFormComplete(data: ExtendedAccountData, type: BackgroundCheckType) {
    const validationSchema = getAccountValidationForBackgroundCheckSchema({ type });
    const result = validationSchema.safeParse(data);

    return result.success;
}
